{
  "colorFormat": "Värvivorming",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
